import React from 'react'
import AdherenceRing from './AdherenceRing'
import HeroStat from './HeroStat'
import PillarColumn from './PillarColumn'
import styles from './ProtocolInfographic.module.css'

export { PRIORITY_STYLES, PILLARS } from './constants'
export { default as PriorityBadge } from './PriorityBadge'
export { default as AdherenceRing } from './AdherenceRing'
export { default as AdherenceRingLight } from './AdherenceRingLight'
export { default as HeroStat } from './HeroStat'
export { default as PillarColumn } from './PillarColumn'
export { default as RecCard } from './RecCard'

export function ProtocolInfographic({
  clientName = 'Client',
  sessionDate,
  data,
  pillar
}) {
  if (!data || !pillar) {
    return null
  }

  const overallAdherence = (data.key_metrics && data.key_metrics.current_adherence) || 0
  const totalCritical = (data.recommendations && data.recommendations.filter((r) => r.priority === 'critical')).length || 0
  const totalRecs = (data.summary && data.summary.total_recommendations) || 0

  return (
    <div className={styles.container}>
      <div className={styles.heroHeader}>
        <div className={styles.headerLeft}>
          <h1 className={styles.headerTitle}>{pillar.label} Recommendations</h1>
        </div>

        <div className={styles.headerRight}>
          <HeroStat label="Adherence" value={`${overallAdherence}%`} accent={pillar.accent} />
          <div className={styles.divider} />
          <HeroStat label="Critical" value={String(totalCritical)} accent="#f5222d" />
          <div className={styles.divider} />
          <HeroStat label="Total Recs" value={String(totalRecs)} accent="#111827" />
          <AdherenceRing value={overallAdherence} accent={pillar.accent} />
        </div>
      </div>

      <div className={styles.pillarGrid}>
        <PillarColumn pillar={pillar} data={data} />
      </div>
    </div>
  )
}
